const SKELETON_WIDTHS = [
    'w-24',
    'w-[70%]',
    'w-1/2',
    'w-[85%]',
    'w-3/5',
    'w-[45%]',
];

export function SidebarMenuSkeleton() {
    return (
        <div className="flex flex-col gap-0.5">
            {SKELETON_WIDTHS.map((width, index) => (
                <div
                    key={index}
                    className="flex items-center justify-between gap-2 rounded-lg px-2 py-1.5 h-9 w-full"
                >
                    <div className={`h-4 ${width} skeleton-item rounded`} />
                    <div className="h-3.5 w-6 skeleton-item rounded shrink-0" />
                </div>
            ))}
        </div>
    );
}
